import ModalConfirmation from "./ModalConfirmation";
export default ModalConfirmation;
